import { observer } from 'mobx-react-lite'
import { useRef, useEffect } from 'react'

import { Typography } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { textToHtml } from 'entities/Message/lib/textToHtml'
import { ConversationCard } from 'pages/chatbot/ui/ChatbotDetails/TabConversation/ConversationCard'
import { useDetailsContext } from '../detailsContext'
import styles from './styles.module.scss'

export const TabObjective = observer(() => {
  const { dataCollectionInstruction, futureBookingMergeFields } = useDetailsContext()
  const entities = useEntitiesContext()
  const ref = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    futureBookingMergeFields.then(() => {
      if (!ref.current) return
      ref.current.innerHTML = textToHtml(entities, {
        text: dataCollectionInstruction,
        replaceNewRow: true,
        extraSpace: true,
      })
    })
  }, [])

  return (
    <section className={styles.wrap}>
      <ConversationCard
        value={
          dataCollectionInstruction ? (
            <Typography tag={'div'} variant={'body-rg-regular'} ariaLabel={'TabObjectiveTitle'}>
              <span ref={ref} />
            </Typography>
          ) : null
        }
        name={
          <>
            Data collection <br />
            instructions
          </>
        }
        placeholder='-'
      />
    </section>
  )
})
